import script from "./SubstatusBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubstatusBar.vue?vue&type=script&setup=true&lang=ts"

import "./SubstatusBar.vue?vue&type=style&index=0&id=2100ca15&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2100ca15"]])

export default __exports__